import ExperianService from "../services/experian.service";
import ContactDetailsService from "../services/contactdetails.service";

const accounts = {
    namespaced: true,
    state: {},
    actions: {
        getContactNumbers(_, urlParameters) {
            return ExperianService.getContactNumbers(urlParameters);
        },
        submitContactNumber(_, urlParameters) {
            return ExperianService.submitContactNumber(urlParameters);
        },
        confirmOtp(_, urlParameters) {
            return ExperianService.confirmOtp(urlParameters);
        },
        getDepartments() {
            return ExperianService.getDepartments();
        },
        getCommunicationOptions() {
            return ExperianService.getCommunicationOptions();
        },
        credisolveSubmit(_, formData) {
            return ExperianService.credisolveSubmit(formData);
        },
        arrangeCallSubmit(_, urlParameters) {
            return ExperianService.arrangeCallSubmit(urlParameters);
        },
        getContactDetails(){
            return ContactDetailsService.getContactDetails();
        }
    },
    getters: {},
    mutations: {},
};

export default accounts;
